import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import analyticsService from "../../services/analytics.service";
import { wsChat } from "../../services/websocket-chat.service";
import { OnyxPrimaryButton } from "../onyx/OnyxButton";

export const LogoutButton = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    analyticsService.trackAuth('logout', 'auth0');
    wsChat.disconnect(true);

    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <OnyxPrimaryButton onClick={handleLogout} chevron={false}>
      Log Out
    </OnyxPrimaryButton>
  );
};
